import { staffCommandOutcomeSchema, staffCoverageGapsSchema, staffCustomerCoverageSchema, staffCustomerSupportSchema, staffTeamSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
const id = (value) => encodeURIComponent(value);
/** `?limit=..&cursor=..` for the parts that were given; nothing for the first page with the default size. */
function pageQuery(page) {
    const query = new URLSearchParams();
    if (page?.limit !== undefined)
        query.set("limit", String(page.limit));
    if (page?.cursor !== undefined)
        query.set("cursor", page.cursor);
    const text = query.toString();
    return text === "" ? "" : `?${text}`;
}
export function createStaffTeamApi(options) {
    const send = createMemoryTransport(options);
    const command = (path, body, commandOptions) => send({
        method: "POST",
        path,
        body,
        schema: staffCommandOutcomeSchema,
        idempotencyKey: commandOptions?.idempotencyKey,
        signal: commandOptions?.signal,
    });
    const read = (path, schema, callOptions) => send({ method: "GET", path, schema, signal: callOptions?.signal });
    return {
        team: (page, o) => read(`/staff/team${pageQuery(page)}`, staffTeamSchema, o),
        coverageGaps: (page, o) => read(`/staff/coverage/gaps${pageQuery(page)}`, staffCoverageGapsSchema, o),
        customerCoverage: (customerId, o) => read(`/staff/customers/${id(customerId)}/coverage`, staffCustomerCoverageSchema, o),
        customerSupport: (customerId, o) => read(`/staff/customers/${id(customerId)}/support`, staffCustomerSupportSchema, o),
        grantRole: (staffUserId, body, o) => command(`/staff/team/${id(staffUserId)}/roles/grant`, body, o),
        revokeRole: (staffUserId, body, o) => command(`/staff/team/${id(staffUserId)}/roles/revoke`, body, o),
        offboard: (staffUserId, body, o) => command(`/staff/team/${id(staffUserId)}/offboard`, body, o),
        reactivate: (staffUserId, body, o) => command(`/staff/team/${id(staffUserId)}/reactivate`, body, o),
        recordUnavailability: (staffUserId, body, o) => command(`/staff/team/${id(staffUserId)}/unavailability`, body, o),
        endUnavailability: (windowId, body, o) => command(`/staff/unavailability/${id(windowId)}/end`, body, o),
        assignPrimary: (customerId, body, o) => command(`/staff/customers/${id(customerId)}/coverage/primary`, body, o),
        reassignPrimary: (customerId, body, o) => command(`/staff/customers/${id(customerId)}/coverage/primary/reassign`, body, o),
        assignBackup: (customerId, body, o) => command(`/staff/customers/${id(customerId)}/coverage/backup`, body, o),
        addTemporaryCoverage: (customerId, body, o) => command(`/staff/customers/${id(customerId)}/coverage/temporary`, body, o),
        endAssignment: (customerId, assignmentId, body, o) => command(`/staff/customers/${id(customerId)}/coverage/${id(assignmentId)}/end`, body, o),
    };
}
